import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Layout } from 'antd'
import PrivateRoute from 'PrivateRoute'
import Dashboard from './views'
import Login from './views/Login'

import 'antd/dist/antd.css'
import 'styles/antd-overrides.css'

// WP - Global CSS
import 'styles/bnbguard.css'

// WP - Individual Page & Component CSS
import 'styles/user-modal.css'
import 'styles/assign-listings.css'
import 'styles/assigned-listings.css'
import 'styles/buildings-list.css'
import 'styles/editor-list.css'
// import 'styles/listing-slideshow.css'
import 'styles/qa-listings.css'
import 'styles/registered-users-list.css'
import 'styles/scrape-history.css'
import 'styles/super-compare.css'

const App = () => {
  return (
    <Layout>
      <Switch>
        <Route path="/login">
          <Login />
        </Route>
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      </Switch>
    </Layout>
  )
}

export default App
